import base64 from 'base-64';

// export const host = 'http://localhost:5000';
export const host = 'https://aygi.am';

export const token = `Basic ${base64.encode('aygi:3mPBlAIH6YqTwV8pCc9N')}`;

export const months = [
    'Հունվար',
    'Փետրվար',
    'Մարտ',
    'Ապրիլ',
    'Մայիս',
    'Հունիս',
    'Հուլիս',
    'Օգոստոս',
    'Սեպտեմբեր',
    'Հոկտեմբեր',
    'Նոյեմբեր',
    'Դեկեմբեր',
]

export const weatherStates = {
    'sunny': 'արևոտ',
    'mostly sunny': 'հիմնականում արևոտ',
    'partly sunny': 'մասամբ արևոտ',
    'intermittent clouds': 'ընդհատվող ամպեր',
    'hazy sunshine': 'մառախլապատ արև',
    'mostly cloudy': 'հիմնականում ամպամած',
    'cloudy': 'ամպամած',
    'dreary (overcast)': 'մռայլ (ծածկված)',
    'fog': 'մառախուղ',
    'showers': 'անձրեվներ',
    'mostly cloudy w/ showers': 'հիմնականում ամպամած և անձրեվներ',
    'partly sunny w/ showers': 'մասամբ արևոտ և անձրեվներ',
    't-storms': 'փոթորիկներ',
    'mostly cloudy w/ t-storms': 'հիմնականում ամպամած և փոթորիկներ',
    'partly sunny w/ t-storms': 'մասամբ արևոտ և փոթորիկներ',
    'rain': 'անձրեվ',
    'flurries': 'ձյուն',
    'mostly cloudy w/ flurries': 'հիմնականում ամպամած և ձյուն',
    'partly sunny w/ flurries': 'մասամբ արևոտ և ձյուն',
    'snow': 'ձյուն',
    'mostly cloudy w/ snow': 'հիմնականում ամպամած և ձյուն',
    'ice': 'սառույց',
    'sleet': '',
    'freezing rain': 'սառեցնող անձրև',
    'rain and snow': 'անձրև և ձյուն',
    'windy': 'քամոտ',
    'clear': 'պարզ',
    'partly cloudy w/ t-storms': 'մասամբ ամպամած և փոթորիկներ',
};

// Get weather icon path. Uses `icon` field from Open-Meteo mapping,
// falls back to `state` for backward compatibility with old AccuWeather data.
export const getWeatherIcon = (locationData) => {
    if (!locationData || !locationData.state) return null;
    const iconName = locationData.icon || locationData.state.toLowerCase();
    return `${host}/public/img/weatherIcons/${iconName}.png`;
};

// All Armenian provinces with display names (matches backend location keys)
export const weatherLocations = [
    { key: 'yerevan',     name: 'Երևան' },
    { key: 'aragatsotn',  name: 'Արագածոտն' },
    { key: 'ararat',      name: 'Արարատ' },
    { key: 'armavir',     name: 'Արմավիր' },
    { key: 'gegharkunik', name: 'Գեղարքունիք' },
    { key: 'kotayk',      name: 'Կոտայք' },
    { key: 'lori',        name: 'Լոռի' },
    { key: 'shirak',      name: 'Շիրակ' },
    { key: 'syunik',      name: 'Սյունիք' },
    { key: 'tavush',      name: 'Տավուշ' },
    { key: 'vayotsDzor',  name: 'Վայոց Ձոր' },
];

export const weekDays = [
    'Երկուշաբթի',
    'Երեքշաբթի',
    'Չորեքշաբթի',
    'Հինգշաբթի',
    'Ուրբաթ',
    'Շաբաթ',
    'Կիրակի',
]
